import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { IAppState, Dispatch } from '../../../../common/state';
import { IJsonQuery } from '../../../../json_query';
import { getTermValue } from '../../../../json_query/reducers/helpers';
import { setTermValue } from '../../../state/advanced/term';
import { Row, InlineParam } from '../markup';

export interface IHasFurnitureProps {
  hasFurniture: boolean | undefined;
  setTerm(key: keyof IJsonQuery, value: boolean): void;
}

class HasFurniture extends React.PureComponent<IHasFurnitureProps> {
  public render() {
    const { hasFurniture, setTerm } = this.props;

    return (
      <Row title="Наличие мебели">
        <InlineParam>
          <ButtonCheckbox
            value={hasFurniture === true}
            onValueChange={setTerm.bind(null, 'has_furniture', !hasFurniture || undefined)}
          >
            С мебелью
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonCheckbox
            value={hasFurniture === false}
            onValueChange={setTerm.bind(
              null,
              'has_furniture',
              hasFurniture !== true ? (hasFurniture === undefined ? false : undefined) : false,
            )}
          >
            Без мебели
          </ButtonCheckbox>
        </InlineParam>
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => {
    const { jsonQuery } = state.filters;

    return {
      hasFurniture: getTermValue('has_furniture')(jsonQuery),
    };
  },
  (dispatch: Dispatch) => ({
    setTerm: (key: keyof IJsonQuery, value: boolean) => {
      dispatch(setTermValue<boolean | undefined>(key, value));
    },
  }),
)(HasFurniture);
